import React, { useEffect, useState } from 'react'
import { GiOvermind } from "react-icons/gi";
import { MdLabelImportant } from "react-icons/md";
import TestQuestion from './TestQuestion';
import {mindMappingTestData} from "../../demodata/Question"
import { fetchEvaluation } from '../../api/Evaluation';
import EditorRenderer from '../EditorRenderer';

// const mindMappingTestData = [
//   {
//     id: 1,
//     header: "Mind Mapping Test কী?",
//     text: [
//       "Mind Mapping Test একটি সৃজনশীল মূল্যায়ন পদ্ধতি, যা শিশুর চিন্তাভাবনা, আইডিয়া তৈরি, তথ্য সংযোগ এবং শেখার কৌশল কেমন তা বিশ্লেষণ করে।",
//     ],
//   },
//   {
//     id: 2,
//     header: "এই টেস্ট কীভাবে কাজ করে?",
//     text: [
//       "এই টেস্টে শিশুকে একটি নির্দিষ্ট বিষয়ে তার চিন্তাধারা চিত্র আকারে সাজাতে বলা হয় (Mind Map)। এরপর তা বিশ্লেষণ করে তার বিশ্লেষণ ক্ষমতা, সৃজনশীলতা এবং শেখার ধরন নির্ধারণ করা হয়।",
//     ],
//   },
//   {
//     id: 3,
//     header: "Mind Map বলতে কী বোঝায়?",
//     text: [
//       "Mind Map হলো একটি গ্রাফিক্যাল চিন্তার মানচিত্র, যেখানে একটি মূল আইডিয়াকে কেন্দ্র করে নানা উপ-আইডিয়া, যুক্তি বা উদাহরণ শাখা-প্রশাখার মতো ছড়িয়ে দেওয়া হয়।",
//     ],
//   },
//   {
//     id: 4,
//     header: "এই টেস্ট শিশুর জন্য কতটা উপকারী?",
//     text: [
//       "Mind Mapping Test শিশুর মস্তিষ্কের গঠন ও তথ্য সংরক্ষণ পদ্ধতি বুঝতে সাহায্য করে। এটি শেখার আগ্রহ বাড়ায়, স্মৃতিশক্তি উন্নত করে, ও সমস্যা সমাধানের দক্ষতা তৈরি করে।",
//     ],
//   },
//   {
//     id: 5,
//     header: "কোন বয়সের শিশুরা এই টেস্ট দিতে পারে?",
//     text: [
//       "৭ থেকে ১৬ বছর বয়সী যেকোনো শিশু এই টেস্ট দিতে পারে।",
//     ],
//   },
//   {
//     id: 6,
//     header: "এই টেস্টের মাধ্যমে কী ধরনের দক্ষতা যাচাই হয়?",
//     text: [
//       "যুক্তিভিত্তিক চিন্তাভাবনা",
//       "আইডিয়া সংগঠনের ক্ষমতা",
//       "সৃজনশীলতা",
//       "তথ্য সংযোগ ও প্রক্রিয়াজাতকরণ",
//       "দৃশ্যমান শেখার দক্ষতা (Visual Learning)",
//     ],
//   },
//   {
//     id: 7,
//     header: "Mind Mapping Test কি শুধু শিক্ষার্থীদের জন্য?",
//     text: [
//       "মূলত শিক্ষার্থীদের জন্য হলেও শিক্ষকরাও এতে উপকৃত হন, কারণ এটি শিক্ষার্থীর শেখার স্টাইল বুঝতে সাহায্য করে।",
//     ],
//   },
//   {
//     id: 8,
//     header: "এই টেস্টে কী ধরনের রিপোর্ট পাওয়া যায়?",
//     text: [
//       "শিশুর চিন্তার ধরন অনুযায়ী বিশ্লেষণ",
//       "সৃজনশীলতা ও বিশ্লেষণ দক্ষতার স্কোর",
//       "শিখন শৈলী (Learning Style) শনাক্তকরণ",
//       "মানসিকভাবে উপযুক্ত শেখার কৌশলের পরামর্শ",
//     ],
//   },
//   {
//     id: 9,
//     header: "এই টেস্ট কীভাবে শিশুর পড়াশোনায় সাহায্য করে?",
//     text: [
//       "Mind Mapping-এর মাধ্যমে জটিল তথ্য সহজে মনে রাখা যায়। পরীক্ষার প্রস্তুতি, প্রজেক্ট প্ল্যানিং এবং রিভিশনের জন্য এটি একটি দারুণ কৌশল।",
//     ],
//   },
//   {
//     id: 10,
//     header: "এই টেস্টের সাথে কী কোনো প্রশিক্ষণ বা গাইডলাইন পাওয়া যায়?",
//     text: [
//       "হ্যাঁ, QS Academy-তে Mind Mapping Test-এর পর শিশু ও অভিভাবকদের জন্য Visual Learning গাইডলাইন এবং কাস্টমাইজড স্টাডি টিপস প্রদান করা হয়।",
//     ],
//   },
// ];

const Mind = () => {

     const [evaluation, setEvaluation] = useState([]);
      const [parsedBlocks, setParsedBlocks] = useState([]);
    
      useEffect(() => {
        const getEvaluation = async () => {
          const data = await fetchEvaluation();
          setEvaluation(data);
        };
        getEvaluation();
      }, []);
    
     const evaluationFilter = evaluation.filter(
        (item) => item.category?.name.toLowerCase() === "mindmappingtest"
      );
    
    useEffect(() => {
      if (!parsedBlocks.length && evaluationFilter.length) {
        let blocksArray = [];
        try {
          const raw = evaluationFilter[0]?.description;
          if (raw) {
            const outer = JSON.parse(raw);
            const inner = outer[0];
            if (inner?.blocks && Array.isArray(inner.blocks)) {
              blocksArray = inner.blocks;
            }
          }
        } catch (err) {
          console.error("Parsing error:", err);
        }
    
        setParsedBlocks(blocksArray);
      }
    }, [evaluationFilter, parsedBlocks.length]);

  return (
      <div className="flex flex-col gap-4">

        {parsedBlocks.length > 0 && <EditorRenderer blocks={parsedBlocks} />}

      

    

     <h2 className="sm:text-2xl text-xl font-bold text-gray-400">
        ভিজিট + ফি: 
      </h2>
        <div className="overflow-x-auto mb-[2rem]">
        <table className="min-w-full">
          <thead>
            <tr>
              <th className="border border-gray-300 text-gray-400 py-1 px-5 text-xl">০৩ টেস্ট প্যাকেজ</th>
              <th className="border border-gray-300 text-gray-400 py-1 px-5 text-xl">সরাসরি</th>
              <th className="border border-gray-300 text-gray-400 py-1 px-5 text-xl">অনলাইন</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-gray-300 text-gray-400 py-2 px-5 text-xl">
                থট টেস্ট + মাইন্ড টেস্ট + স্বাস্থ্যগত টেস্ট
              </td>

              <td className="border border-gray-300 text-gray-400 py-2 px-5 text-xl text-center">
                2000/-
              </td>
              <td className="border border-gray-300 text-gray-400 py-2 px-5 text-xl text-center">
                2500/-
              </td>
            </tr>
            
          </tbody>
        </table>
      </div>

      <p className="text-gray-400  text-xl text-justify">
        আপনার সন্তানকে REVIVE করতে আজই Mind Mapping Test করুন !
      </p>
      

      <div className="flex gap-4 items-center mb-[4rem]">
        <p className="text-gray-300  text-xl">
          অথবা WhatsApp করুন-{" "}
          <strong className="text-[#22BEFF]">01711055752</strong>
        </p>
           <button  className="px-[1.25rem] py-[0.5rem] text-base border border-[#22beff]  text-[#22beff] hover:text-[#081a28] hover:bg-[#22beff] rounded-md font-bold cursor-pointer" onClick={() => window.open("https://forms.gle/MWgJ4zyJh3nDr6YdA", "_blank")}>
            অ্যাপয়েন্টমেন্ট
          </button>
      </div>

       <TestQuestion questionData={mindMappingTestData}/>
    </div>
  )
}

export default Mind